import React from 'react';
import { FileDrop } from 'react-file-drop';
import { File, Trash2, ExternalLink } from 'react-feather';
import { translate } from '../../translations';
import { Paragraph2 } from '../../theme/styles';
import LoadingBar from '../LoadingBar/LoadingBar';
import './FileUploader.css';

export class FileUploader extends React.PureComponent {
    constructor(props) {
        super(props);
        this.inputOpenFileRef = React.createRef();
    }

    getTargetClassName = (fileName, disabled, importErrorMsg) => {
        const baseStyle = ['file-drop-target'];

        baseStyle.push(fileName ? 'file-drop-selected' : 'file-drop-empty');

        if (disabled) {
            baseStyle.push('file-drop-disabled');
        }

        if (!fileName && importErrorMsg?.length > 0) {
            baseStyle.push('file-drop-error');
        }

        return baseStyle.join(' ');
    };

    renderLoadingBar = (loadingProgressData) => (
        <div className="fileUploaderLoadingBarWrapper">
            <LoadingBar loadingProgressData={loadingProgressData} />
        </div>
    );

    showOpenFileDialog = () => {
        this.inputOpenFileRef.current.click();
    };

    onChangeFile = (event, onFileSave) => {
        event.stopPropagation();
        event.preventDefault();
        onFileSave(event.target.files[0]);
    };

    getFileListAcceptedTypes = (fileAccept) => {
        const acceptedTypes = [];

        fileAccept.forEach((type) => {
            switch (type) {
                case '.csv':
                    acceptedTypes.push('text/csv');
                    break;
                case '.xlsx':
                    acceptedTypes.push('application/vnd.openxmlformats-officedocument.spreadsheetml.sheet');
                    break;
                case '.pdf':
                    acceptedTypes.push('application/pdf');
                    break;
                default:
                // do nothing. We don't want willy-nilly add other types.
            }
        });

        return acceptedTypes;
    };

    renderFileDrop = () => {
        const {
            fileName,
            fileUploadText,
            fileAcceptTypes,
            importErrorMsg,
            disabled,
            onFileSave,
            onFileDelete,
            showLink,
        } = this.props;

        return (
            <FileDrop
                targetClassName={this.getTargetClassName(fileName, disabled, importErrorMsg)}
                onDrop={(files) => {
                    if (!disabled && (!fileAcceptTypes || this.getFileListAcceptedTypes(fileAcceptTypes).includes(files[0].type))) {
                        onFileSave(files[0]);
                    }
                }}
            >
                {fileName ? (
                    <div className="file-drop-selected-container">
                        <div
                            className={`fileInputContainer ${disabled ? 'disabled' : ''}`}
                            style={Paragraph2}
                        >
                            {fileName}
                        </div>
                        {!disabled && (
                            <Trash2
                                size={18}
                                className="fileDeleteIcon"
                                onClick={onFileDelete}
                            />
                        )}
                        {showLink?.length > 0 && disabled && (
                            <ExternalLink
                                size={16}
                                className="showLinkIcon"
                                onClick={() => window.open(showLink, '_blank')}
                            />
                        )}
                    </div>
                ) : (
                    <div className={`file-drop-empty-container ${disabled ? 'disabledContainer' : ''}`}>
                        <File size={18} className={`fileUploadIcon ${disabled ? 'disabled' : ''}`} />
                        <span>
                            {fileUploadText || translate('drop_your_csv_here_or')}
                            &nbsp;
                        </span>
                        <span
                            className={disabled ? 'disabled' : 'fileBrowseTextButton'}
                            onClick={disabled ? () => false : this.showOpenFileDialog}
                            role="button"
                            tabIndex={-1}
                        >
                            {translate('browse')}
                        </span>
                        <input
                            ref={this.inputOpenFileRef}
                            type="file"
                            accept={fileAcceptTypes}
                            style={{ display: 'none' }}
                            onChange={(event) => this.onChangeFile(event, onFileSave)}
                        />
                    </div>
                )}
            </FileDrop>
        );
    };

    /* This component assume that you can only upload 1 File, need to rework if you want options to upload multiple Files */
    render() {
        const { loadingProgressData } = this.props;
        return (
            <>
                {loadingProgressData?.active ? this.renderLoadingBar(loadingProgressData) : this.renderFileDrop()}
            </>
        );
    }
}

export default FileUploader;
